module.exports = __webpack_public_path__ + "static/media/ooppah_ilustracao_video.b4c562e2.png";